export default __webpack_public_path__ + "static/media/capitor.912bb38f.jpg";